import React, { useState, useEffect, useRef, } from 'react';
import { FormGroup, Label, InputGroup, Input, Button, Modal, ModalBody, ModalFooter, Form, } from 'reactstrap';
import { sumBy, isEmpty, sum, groupBy, get, keyBy, omit, mapValues, } from 'lodash';
import { useDebounce, useToggle, useList, } from 'react-use';
import { toast, } from 'react-toastify';
import jsbarcode from 'jsbarcode';
import { jsPDF } from 'jspdf';
import { PDFDocument, } from 'pdf-lib';
import fileDownload from 'js-file-download';
import dedent from 'dedent';

import env from '../../env';
import { drawUnknownInventoryLabel, } from '../../label';
import okSoundSrc from '../../sounds/ok.mp3';
import ngSoundSrc from '../../sounds/ng.mp3';
import firebase, { functions } from '../../firebase';
import { batch } from '../../shared/firebase';
import { isMobile, safePrefix, } from '../../util';
import useFormState from '../hooks/useFormState';
import ProductSelectOptionLabel from '../ProductSelectOptionLabel';
import Field from '../Field';
import { idWithTenant, } from '../../shared/util';
import ListForm from '../ListForm';
import PendingItemForm from '../forms/PendingItemForm';
import useCollectionFetch from '../hooks/useCollectionFetch';
import useDocumentSubscription from '../hooks/useDocumentSubscription';

const labelWidth = 52.5;
const labelHeight = 29.7;
const { entries, keys, } = Object;
const db = firebase.firestore();
const unknownInventoriesRef = db.collection('unknownInventories');
const tenantsRef = db.collection('tenants');
const printBarcode = functions.httpsCallable('printBarcode');

export default function UnknownShelvingModal(props) {
  const { isOpen, tenants, locations, unknownReceivingRequest, } = props;
  const [unknownBarcodeValue, setUnknownBarcodeValue] = useState('');
  const [locationKeyValue, setLocationKeyValue] = useState('');
  const ngAudioEl = useRef(null);
  const okAudioEl = useRef(null);
  const unknownBarcodeInput = useRef(null);
  const locationInput = useRef(null);
  const playAudio = (audio) => {
    audio.currentTime = 0;
    audio.play();
  };
  const onClickClose = () => {
    props.onClickClose();
  };
  useDebounce(async (e) => {
    if(isEmpty(unknownBarcodeValue)) return;

    const fail = _ => [setUnknownBarcodeValue(''), playAudio(ngAudioEl.current)];
    const [, tenantId, receivingRequestId] = safePrefix(unknownBarcodeValue).match(new RegExp(`^(${env('TENANT_PREFIX')}\\d+)-(W\\d+)-U$`)) || [];
    if(!tenantId || !receivingRequestId) return fail();

    const { exists } = await tenantsRef.doc(tenantId).collection('receivingRequests').doc(receivingRequestId).get();
    if(!exists) return fail();

    locationInput.current.focus();
  }, 300, [unknownBarcodeValue]);
  useDebounce(async (e) => {
    if(isEmpty(locationKeyValue)) return;

    const location = locations.find(_ => _.sortKey === locationKeyValue);
    if(!location) return [setLocationKeyValue(''), playAudio(ngAudioEl.current)];

    playAudio(okAudioEl.current);
    setUnknownBarcodeValue('');
    setLocationKeyValue('');
    const [, tenantId, receivingRequestId] = safePrefix(unknownBarcodeValue).match(new RegExp(`^(${env('TENANT_PREFIX')}\\d+)-(W\\d+)-U`));
    const batch = db.batch();
    batch.set(unknownInventoriesRef.doc(), {
      tenantId,
      receivingRequestId,
      receivingRequestFullId: [tenantId, receivingRequestId].join('-'),
      unknownBarcode: safePrefix(unknownBarcodeValue),
      locationId: location.id,
      status: 'shelved',
      createdAt: new Date(),
    });
    await batch.commit();
    toast.success('入庫しました');
  }, 300, [locationKeyValue]);

  return (
    <Modal isOpen={isOpen}>
      <div className="modal-header">
        <div className="w-100 d-flex justify-content-between">
          <h5 className="modal-title">
            不明入庫
          </h5>
        </div>
      </div>
      <ModalBody>
        <div>
          <div className="mt-2">
            <FormGroup>
              <Label>不明バーコード</Label>
              <Input innerRef={unknownBarcodeInput} value={unknownBarcodeValue} onChange={_ => setUnknownBarcodeValue(_.target.value)} />
            </FormGroup>
            <FormGroup>
              <Label>ロケーション</Label>
              <Input innerRef={locationInput} value={locationKeyValue} onChange={_ => setLocationKeyValue(_.target.value)} disabled={isEmpty(unknownBarcodeValue)} />
            </FormGroup>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button className="cancel" color="secondary" onClick={onClickClose}>閉じる</Button>
      </ModalFooter>
      <audio src={ngSoundSrc} ref={ngAudioEl} />
      <audio src={okSoundSrc} ref={okAudioEl} />
    </Modal>
  );
};
